export default "__VITE_ASSET__Ke_eEhay__"